import { environments, IEnvironment } from './environments';
export const environment: IEnvironment = {
  name: environments.production,
  version: '1.0.0',
  url: 'https://agency-api.maharah.com',
  identityServer: 'https://auth.maharah.com',
  host: 'https://agency.maharah.com',
};
